import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const PaymentMangerSchema: FormFieldSchema[] = [
  {
    id: "account",
    noneStyle: true,
    type: FormFieldType.Group,
    schemas: [
      {
        id: "name",
        label: "결제 관리자 이름",
        placeholder: "이름을 입력해주세요..",
        type: FormFieldType.Text,
      },
      {
        id: "email",
        label: "결제 관리자 이메일 주소",
        placeholder: "이메일 주소를 입력해주세요.",
        type: FormFieldType.Text,
      },
    ],
  },
];
